// extracted by mini-css-extract-plugin
export default {"page":"NotFound_page__5jj4D","content":"NotFound_content__Ql5ZD"};